/**
 * @copyright Copyright MIDAS Education, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {
    id: 'navigation.data-suites.transfer-adapters',
  },
});

const TransferAdaptersItem = () => (
  <RouteLinkItem
    route="midas/data-forge/transfer-adapters"
    title={messages.title}
  />
);

export default TransferAdaptersItem;
